const redirectToAccounts = (path = '/', redirectUri) => {
	const accountsRedirectUri = redirectUri || process.env.REACT_APP_CONSOLE_URL

	window.location.href =
		process.env.REACT_APP_ACCOUNTS_URL +
		path +
		'?redirect_uri=' +
		accountsRedirectUri +
		'&response_type=token' +
		'&client_id=' +
		process.env.REACT_APP_ACCOUNTS_CLIENTID
}

export default redirectToAccounts



// WEBPACK FOOTER //
// ./src/utils/redirectToAccounts.js